export default __webpack_public_path__ + "static/media/one-icon.58c21ba9.svg";